import { render, staticRenderFns } from "./BimModel.vue?vue&type=template&id=7b1a7c3a&scoped=true"
import script from "./BimModel.vue?vue&type=script&lang=js"
export * from "./BimModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a7c3a",
  null
  
)

export default component.exports